/**
 * Identity-Score: Fachliche, persönliche und unternehmerische Eignung.
 *
 * Heuristik (Konzept §4.2 Dimension 1, in Score-Form gegossen):
 *   - Basis 20
 *   - mind. eine branchenrelevante Qualifikation: +25
 *   - hat unternehmerische Erfahrung: +15
 *   - ≥ 3 Jahre selbständig: +10 (nur falls bereits selbständig)
 *   - mind. 5 Jahre Branchenerfahrung: +15
 *   - ≥ 3 dokumentierte persönliche Eigenschaften: +10
 *   - klares USP (≥ 50 Zeichen): +5
 * Cap auf [0, 100].
 *
 * Bewusst keine Negativabzüge — Negativsignale werden über
 * `getRiskIndicators` separat geführt, damit der Score additiv-transparent
 * bleibt.
 */
import type { ScoreValue } from '../schema/brands.js';
import type { IdentityData } from '../schema/dimensionData.js';
import { clampScore } from './internal/clamp.js';

export function computeIdentityScore(data: IdentityData): ScoreValue {
  let score = 20;

  const hasIndustryRelevantQual = data.qualifications.some((q) => q.industryRelevant);
  if (hasIndustryRelevantQual) score += 25;

  if (data.hasEntrepreneurialExperience) score += 15;

  if ((data.yearsSelfEmployed ?? 0) >= 3) score += 10;

  if ((data.industryExperienceYears ?? 0) >= 5) score += 15;

  if (data.personalTraits.length >= 3) score += 10;

  if ((data.usp ?? '').trim().length >= 50) score += 5;

  return clampScore(score);
}
